import {
  colorCss,
  FontProps,
  fontCss,
  lineHeightCss,
  mobileFontCss,
  mobileLineHeightCss,
} from 'common/utils/styleUtilsNew'
import React from 'react'
import styled, { css } from 'styled-components'

export interface ProductWrapperUiProps extends FontProps {
  lineHeight?: number
  mobileLineHeight?: number
}

export const ProductWrapper = styled.div<ProductWrapperUiProps>`
  ${colorCss}
  ${fontCss}
  ${lineHeightCss}

  &:not(:first-child) {
    margin-top: 12px;
  }

  ${p => p.theme.phone} {
    ${mobileFontCss}
    ${mobileLineHeightCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
      ${mobileLineHeightCss}
    `}
`
